<hr>
<div class="qr-container">
  <img 
    [src]="qrCodeBase64" 
    alt="QR Code" 
    class="qr-image"
    #qrImage
  />
  <button (click)="downloadQrCode()" class="download-button">
    Télécharger le QR Code
  </button>
</div>
